const dateOnlyHelper = {
	date(date: Date) : string {
		const y = date.getFullYear();
		const m = date.getMonth() + 1;
		const d = date.getDate();

		const month = m < 10 ? `0${m}` : m + '';
		const day = d < 10 ? `0${d}` : d + '';

		return `${y}-${month}-${day}`;
	},

	nowDate() {
		return this.date(new Date());
	},

	toLocalDate(dateOnly: string | null, timeOnly: string | null) : string {

		if (!dateOnly ||
			!timeOnly) {
			return '';
		}

		const offsetMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;

		const toDate = () : Date => {
			/* dateOnly example: '2025-12-31' */
			/* timeOnly example: '10:30:59' */
			const dateSplitter = '-', timeSplitter = ':';
			
			const [year, month, date] = dateOnly.split(dateSplitter).map(Number);
			const [hour, minute, second] = timeOnly.split(timeSplitter).map(Number);
	
			return new Date(year, month-1, date, hour, minute, second);
		};

		const utcDateTime = toDate();
		const localDateTime = new Date(utcDateTime.getTime() - offsetMilliseconds);
		const localTimeOnly = this.date(localDateTime);

		return localTimeOnly;
	},

	/**
	 * Converts to UTC date from pair DateOnly+TimeOnly
	 * @param dateOnly '2025-12-31'
	 * @param timeOnly '10:30:59'
	 */
	toUtcDate(dateOnly: string | null, timeOnly: string | null) : string {

		if (!dateOnly ||
			!timeOnly) {
			return '';
		}

		const toDate = () : Date => {
			const dateSplitter = '-', timeSplitter = ':';
			
			const [year, month, date] = dateOnly.split(dateSplitter).map(Number);
			const [hour, minute, second] = timeOnly.split(timeSplitter).map(Number);
	
			return new Date(year, month-1, date, hour, minute, second);
		};

		const dateTime = toDate();
		const offsetMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;

		const utcDateTime = new Date(dateTime.getTime() + offsetMilliseconds);
		const utcDateOnly = this.date(utcDateTime);

		return utcDateOnly;
	}
}
export default dateOnlyHelper;